"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createButtonDefaultProps = exports.createButtonTheme = void 0;
exports.createButtonTheme = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            background: palette.common.white,
            color: palette.primary.main,
            height: 64,
            borderRadius: 32,
            fontSize: 16,
            lineHeight: "12px",
            paddingLeft: 30,
            paddingRight: 30,
            letterSpacing: 0,
            "&:hover": {
                "@media (hover: none)": {
                    background: palette.common.white,
                },
                background: palette.common.white,
            },
        },
        label: {
            textTransform: "none",
        },
        outlined: {
            borderColor: palette.primary.main,
            borderWidth: 2,
            padding: undefined,
            "&:hover": {
                background: palette.common.white,
                borderColor: palette.primary.dark,
                color: palette.primary.dark,
                "@media (hover: none)": {
                    background: palette.common.white,
                    borderColor: palette.primary.dark,
                    color: palette.primary.dark,
                },
            },
        },
        contained: {
            backgroundColor: palette.primary.main,
            color: palette.common.white,
            "&:hover": {
                backgroundColor: palette.primary.dark,
                "@media (hover: none)": {
                    backgroundColor: palette.primary.dark,
                },
            },
        },
        text: {
            backgroundColor: "transparent",
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        sizeSmall: {
            height: 48,
            borderRadius: 32,
            fontSize: 14,
            lineHeight: "10px",
            paddingLeft: 25,
            paddingRight: 25,
        },
        sizeLarge: {
            height: 72,
            borderRadius: 36,
            fontSize: 20,
            lineHeight: "23px",
            paddingLeft: 32,
            paddingRight: 32,
        },
    });
};
exports.createButtonDefaultProps = function () { return ({
    disableElevation: true,
    disableTouchRipple: true,
    disableFocusRipple: true,
}); };
